import Divider from "../../components/divider/Divider";
import Transition from "../../components/transition/Transition";
import ContactForm from "./contactForm/ContactForm";
import ContactHero from "./contactHero/ContactHero";

export default function Contact (){
    return(
        <Transition emojiName="handshake">

            <ContactHero />

            <Divider />

            <ContactForm />

        </Transition>
    );
}